import { CacheKey } from '@eliadmin/core/src/api/constants';
import type { PaginationMeta } from '@eliadmin/core/src/api/api-types';
import type { Product } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';
import type { CategoryStore } from '@eliadmin/core/src/stores/category-store';
import { buildProductsQuery } from '@eliadmin/core/src/utils/product-utils';

export type CategoryProductsPage = { data: Product[]; meta: PaginationMeta };

export function buildCategoryProductsQuery({
  categoryId,
  results,
  filter,
}: {
  categoryId: number;
  results: number;
  filter: CategoryStore['filter'];
}) {
  const query = buildProductsQuery({
    attributes: filter.attributes,
    categories: [categoryId],
    manufacturers: filter.manufacturers,
    suppliers: filter.suppliers,
    availabilities: filter.availabilities,
    results,
    order: filter.sort.order,
    orderBy: filter.sort.orderBy,
    price_from: filter.price_min,
    price_to: filter.price_max,
    discounted: filter.discounted,
  });
  delete query.page;
  return query;
}

export function categoryProductsKey({
  query,
  page,
  locale,
  authToken,
}: {
  query: ReturnType<typeof buildCategoryProductsQuery>;
  page: number;
  locale: string;
  authToken?: string;
}) {
  return [CacheKey.PRODUCTS, 'mediatip-category', locale, authToken ?? null, page, query] as const;
}

export type CategoryProductsSeed = {
  key: ReturnType<typeof categoryProductsKey>;
  data: CategoryProductsPage;
  updatedAt: number;
};

/** Public seed must never initialize another page, filter, locale, or customer's query. */
export function matchingCategorySeed(
  seed: CategoryProductsSeed | undefined,
  key: ReturnType<typeof categoryProductsKey>,
) {
  return seed && JSON.stringify(seed.key) === JSON.stringify(key) ? seed : undefined;
}
